/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react";
import { useFaunaContext } from "../../../providers/FaunaProvider";
import { BsDownload } from "react-icons/bs";
import { GET_TERM_REPORT } from "../../../faunadb/queries/term";
import { getWeekday, toCSV } from "../../../faunadb/helpers/utils";

const TermSummary = ({ termId }) => {
  const { queries, client } = useFaunaContext();
  const [summary, setSummary] = useState(null);
  const csvData = [];

  async function getTermSummary() {
    queries.term
      .GET_TERM_SUMMARY(client, termId)
      .then((response) => setSummary(response));
  }
  useEffect(() => {
    getTermSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {summary && (
        <div style={{ color: "white" }}>
          <div>
            Number of Unique Student: {summary.number_of_unique_student}
          </div>
          <div>Courses Applied: {summary.count}</div>
          <div>Total Credit: {summary.total_amount}</div>
          <div
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              // getReport();
            }}
          >
            <BsDownload size={30}></BsDownload>
          </div>
        </div>
      )}
    </>
  );
};

export default TermSummary;
